/* loading-compiled.tsx generated by @compiled/babel-plugin v0.35.0 */
import "./loading-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Spinner from '@atlaskit/spinner';
var loadingStyles = null;
export var Loading = function Loading(_ref) {
  var _ref$dimensions = _ref.dimensions,
    _ref$dimensions2 = _ref$dimensions === void 0 ? {} : _ref$dimensions,
    width = _ref$dimensions2.width,
    height = _ref$dimensions2.height;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": 'media-svg-loading',
    role: "status",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: {
      width: width,
      height: height
    },
    className: ax(["_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _1bah1h6o"])
  }, /*#__PURE__*/React.createElement(Spinner, null));
};